// @format
export class Host {
  id: number = -1;
  name: string = '';
  originUrl: string = '';
  forceSSL: boolean = false;
  isSystemHostname: boolean = false;
  hasCertificate: boolean = false;
}
